import { Component, HostBinding } from '@angular/core';
import { Storage } from '@ionic/storage';
import { AlertController, LoadingController, NavController, Keyboard, Platform } from 'ionic-angular';
import { Api } from '../../providers/api';
import { PostLoginNotAcceptableError } from '../../providers/api/errors/PostLoginNotAcceptableError';
import { SubscriptionService } from '../../providers/subscription-service';
import { UserService } from '../../providers/user-service';
import { ForgotPasswordPage } from '../forgot-pasword/forgot-password';
import { HomePage } from '../home/home';
import { RegisterPage } from '../register/register';
import { UnauthorizedError } from '../../providers/api/errors/UnauthorizedError';
import { Subscription, Observable } from 'rxjs';
import { UnprocessableEntityError } from '../../providers/api/errors/UnprocessableEntityError';
import { Device } from '@ionic-native/device';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics';
@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {

    @HostBinding('class.keyboard-visible') public keyboardVisible: boolean = false;

    public email: string = '';
    public password: string = '';

    public onKeyboardWillShow: Subscription;
    public onKeyboardWillHide: Subscription;

	constructor(
        public api: Api,
        public alertCtrl: AlertController,
        public analytics: FirebaseAnalytics,
        public device: Device,
        public keyboard: Keyboard,
        public loadingCtrl: LoadingController,
        public platform: Platform,
        public storage: Storage,
        public navCtrl: NavController,
        public subscriptionService: SubscriptionService,
        public userService: UserService,
    ) {

    }

    public ionViewDidEnter() {
        this.analytics.setCurrentScreen('Login');
    }

    public ionViewWillEnter() {
        let keyboardWillShow = this.keyboard.willShow.asObservable();
        let keyboardWillHide = this.keyboard.willHide.asObservable();

        if (this.platform.is('android')) {
            keyboardWillShow = Observable.fromEvent(window, 'keyboardWillShow');
            keyboardWillHide = Observable.fromEvent(window, 'keyboardWillHide');
        }

        this.onKeyboardWillShow = keyboardWillShow.subscribe(height => {
            this.keyboardVisible = true;
        });
        this.onKeyboardWillHide = keyboardWillHide.subscribe(() => {
            this.keyboardVisible = false;
        });
    }

    public ionViewWillLeave() {
        if (this.onKeyboardWillHide && !this.onKeyboardWillHide.closed) {
            this.onKeyboardWillHide.unsubscribe();
        }

        if (this.onKeyboardWillShow && !this.onKeyboardWillShow.closed) {
            this.onKeyboardWillShow.unsubscribe();
        }
    }

    public continueAsGuest() {
        if (this.navCtrl.canGoBack()) this.navCtrl.pop();
        else {
            this.navCtrl.setRoot(HomePage, null, {
                animate: true,
                direction: 'forward'
            });
        }
    }

	public goToRegister() {
		this.navCtrl.push(RegisterPage, {});
	}

	public goToForgotPassword() {
		this.navCtrl.push(ForgotPasswordPage, {});
    }

    public login(token?: string) {
        let loading = this.loadingCtrl.create();
        loading.present();

        this.api.postLogin({
            token: token,
            email: this.email,
            password: this.password,
            device: {
                cordova: this.device.cordova,
                model: this.device.model,
                platform: this.device.platform,
                uuid: this.device.uuid,
                version: this.device.version,
                manufacturer: this.device.manufacturer,
                is_virtual: this.device.isVirtual,
                serial: this.device.serial,
            },
        }).finally(() => {
            loading.dismiss();
        }).subscribe(async response => {
            this.storage.set('api_token', response.token);
            this.api.setToken(response.token);
            this.analytics.logEvent('login', { method: 'in_app' });

            await Promise.all([
                this.subscriptionService.setAndStore(response.subscription),
                this.userService.setAndStore(response.user),
            ]);

            if (this.navCtrl.canGoBack()) this.navCtrl.pop();
            else {
                this.navCtrl.setRoot(HomePage, null, {
                    animate: true,
                    direction: 'forward'
                });
            }
        }, error => {
            if (error instanceof PostLoginNotAcceptableError) {
                let alert = this.alertCtrl.create({
                    title: 'Too many devices',
                    message: 'You have already signed into the maximum number of allowed devices. If you still want to log in, please choose a device to sign out first.',
                    buttons: [{
                        text: 'Cancel'
                    }, {
                        text: 'OK',
                        handler: token => {
                            this.login(token);
                        }
                    }]
                });

                let sessions = error.sessions.sort((a, b) => {
                    if (a.last_seen_at < b.last_seen_at) return -1;
                    if (a.last_seen_at > b.last_seen_at) return 1;
                    return 0;
                });

                for (let session of sessions) {
                    alert.addInput({
                        type: 'radio',
                        label: session.last_seen_at.toString(),
                        value: session.token,
                    });
                }

                alert.present();

                return;
            }

            if (error instanceof UnauthorizedError) {
                let alert = this.alertCtrl.create({
                    title: 'Invalid Details',
                    message: 'The email address or password you have entered is incorrect. Please try again.',
                    buttons: [{
                        text: 'OK'
                    }]
                });

                alert.present();

                return;
            }

            if (error instanceof UnprocessableEntityError) {
                let errors = this.api.errorsToUl(error.errors);

                let alert = this.alertCtrl.create({
                    cssClass: 'alert-with-error-list',
                    title: 'Invalid Details',
                    subTitle: 'There were one or more issues with the information you entered',
                    message: errors.outerHTML,
                    buttons: [{
                        text: 'OK'
                    }]
                });

                alert.present();

                return;
            }

            let alert = this.alertCtrl.create({
                title: 'Error',
                message: 'An unknown error has occured. Please try again.',
                buttons: [{
                    text: 'OK'
                }]
            });

            alert.present();
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts